// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"730":"513294f0c04a","1483":"03d6c8be073e","4449":"7d4a5daac935","4888":"623ad0123580"}[chunkId] + ".css";
};